import type { Map as MapLibreMap } from 'maplibre-gl';

export function isMapActive(map: MapLibreMap | null): map is MapLibreMap {
    return map !== null && !map._removed;
}

/** True when style-backed calls are safe; context loss can clear the style before `_removed` changes. */
export function isMapUsable(map: MapLibreMap | null | undefined): map is MapLibreMap {
    return map != null && !map._removed && map.style != null;
}

export function removeMapDeferred(map: MapLibreMap): void {
    setTimeout(() => {
        if (isMapActive(map)) {
            try {
                map.remove();
            } catch {
                // Teardown after WebGL context loss can throw, and an uncaught timer error only adds Bugsnag noise.
            }
        }
    }, 0);
}
